/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  first:'',
  master:{
    firstname:'',
    lastname:'',
    email:'',
    password:'',
  },
  banners:[],
  banner_select:{
    name:'',
    order:'',
    createdate:'',
    key:'',
  },
  company: [],
  department: [],
  userOption:[],
  rewardOption:[],
  userOptionTrueWallet:[],
  rewards:[],
  users: [],
  redeems:[],
  redeem_select:{
    reward:'',
    username:'',
    web:'',
    name:'',
    address:'',
    amphur:'',
    province:'',
    zipcode:'',
    mobile:'',
    code:'',
    detail:'',
    detailmore:'',
    color:'',
    size:'',
    createdate:'',
    status:'',
    remark:'',
    number:'',
    deliveryby:'',
  },
  reward_select:{
    reward:'',
    code:'',
    detail:'',
    color:'',
    size:'',
    createdate:'',
  },
  user_select:{
    six:'',
    five:'',
    five2:'',
    four:'',
    three:'',
    twotop:'',
    twobottom:'',
    datetime:'',
    datetime2:'',
    three2:'',
    two:'',
    two2:'',
    key:'',
  },
  user_select2:[],
  popup:false,
  popup2:false,
  employee:[],
  depositTotal:0,
  withdrawTotal:0,
  total:0,
  history:[],
  user:{
    avatar_path:'https://image.freepik.com/free-vector/businessman-profile-cartoon_18591-58479.jpg',
    avatar:'https://image.freepik.com/free-vector/businessman-profile-cartoon_18591-58479.jpg',
    code:null,
    email:null,
    firstname:null,
    lastname:null,
    job_title:null,
    manager:null,
    mobile:null,
    role:null,
    status:null,
    password:null,
    location:{
      add_line_1:null,
      add_line_2:null,
      subdistrict:null,
      district:null,
      province:null,
      post_code:null,
    },
    social_links:{
      twitter:null,
      facebook:null,
      instagram:null,
      github:null,
      line:null,
      slack:null,
    },
  },
  userdefault:{
    avatar_path:'https://image.freepik.com/free-vector/businessman-profile-cartoon_18591-58479.jpg',
    avatar:'https://image.freepik.com/free-vector/businessman-profile-cartoon_18591-58479.jpg',
    code:null,
    email:null,
    firstname:null,
    lastname:null,
    job_title:null,
    manager:null,
    mobile:null,
    role:null,
    status:null,
    password:null,
    location:{
      add_line_1:null,
      add_line_2:null,
      subdistrict:null,
      district:null,
      province:null,
      post_code:null,
    },
    social_links:{
      twitter:null,
      facebook:null,
      instagram:null,
      github:null,
      line:null,
      slack:null,
    },
  },
}
